import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api-client";

export function useMigrationAck() {
  const [ackedAt, setAckedAt] = useState<string | null | undefined>(undefined);

  const refresh = useCallback(async () => {
    try {
      const res = await api.get<{ ackedAt: string | null }>("/roles/migration-ack");
      setAckedAt(res.ackedAt);
    } catch {
      setAckedAt(null);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const ack = useCallback(async () => {
    await api.post("/roles/migration-ack", {});
    setAckedAt(new Date().toISOString());
  }, []);

  return { ackedAt, ack, isLoading: ackedAt === undefined };
}
